var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[(_vm.loaded)?_c('editor-x',{attrs:{"read-only":true,"programming-language":_vm.programmingLanguage,"code":_vm.code,"additional-options":_vm.additionalOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }